var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dv-digital-flop"},[_c('canvas',{ref:"digital-flop"})])}
var staticRenderFns = []

export { render, staticRenderFns }